import { Dispatch, SetStateAction, useState } from "react";

import Icon from "@components/icon";
import RaQForm from "@modules/requestAQuote/components/RaQForm";
import { ITripPreferencesProps } from "./RaQFullForm";
import { Dayjs } from 'dayjs'

export interface IRAQStickyContainerProps {
  calendarInputProps: {
    setShowCalendar: Dispatch<SetStateAction<boolean>>;
    inputDate: string | null;
  };
  isMobile: boolean | undefined;
  tripPreferencesProps: ITripPreferencesProps;
  phone: {
    phoneAction: string;
    phoneNumber: string | undefined;
  };
  dates: {
    startDate: Dayjs | null;
    endDate: Dayjs | null;
  };
}

const RAQStickyContainer = ({
                              calendarInputProps,
                              isMobile,
                              tripPreferencesProps,
                              phone,
                              dates,
                            }: IRAQStickyContainerProps): JSX.Element => {
  const [step, setStep] = useState(1);
  return (
    <>
      <div className={`sticky h-auto max-w-[420px] rounded-2xl bg-blue-5 ml-auto raq-form-shadow`}>
        <div
          className="px-8 py-6"
          aria-label="Get a Quote (Step 1 of 2)"
        >
          <div className="mx-auto mb-4 flex flex-col w-fit">
            <div className="flex justify-center items-center">
              {step == 2 &&
                <div className="p-[12px] hover:cursor-pointer" onClick={() => setStep(1)}>
                  <Icon name="icon_form_back_arrow" width={24} height={24}/>
                </div>
              }
              <span className="text-center text-h2">Get Local, Expert Advice.</span>
            </div>
            {step === 1 && (
              <span className="text-center text-p text-[#364152]">
                Let us design your worry-free trip.
              </span>
            )}
          </div>
          <RaQForm
            calendarInputProps={calendarInputProps}
            step={step}
            setStep={setStep}
            isMobile={isMobile}
            tripPreferencesProps={tripPreferencesProps}
            isOnStickyRaQ={true}
            phone={phone}
            dates={dates}
          />
        </div>
      </div>
    </>
  );
};

export default RAQStickyContainer;
